import moment from 'moment';

import { abbrNum } from 'utils/helper/common';
import { GRAPH_COLORS } from 'utils/graphs/utils';

import type {
  BarGraphDataZoom,
  BarGraphXAxisOptions,
  BarGraphYAxisOptions
} from 'types';

type StringNumber = string | number;

const ENGAGEMENT_RATE = 'engagementRate';
const WEEK = 'week';
const MONTH = 'month';

export const getColorOptions = (): Array<string> => GRAPH_COLORS;

export const getFormattedDate = (value: StringNumber, dateInterval: string): string => {
  if ([WEEK, MONTH].includes(dateInterval)) {
    return moment(value).format('Do MMM');
  }

  // 1+ years
  return moment(value).format('MMM YYYY');
};

export const getXAxisOptions = (data: Array<StringNumber>, dateInterval: string): BarGraphXAxisOptions => ({
  type: 'category',
  data,

  axisTick: {
    alignWithLabel: true,
    length: 9
  },

  axisLine: {
    onZero: false,
    lineStyle: {
      color: '#e0e0e0'
    }
  },

  axisLabel: {
    color: '#3a3a3a',
    margin: 13,
    formatter: value => getFormattedDate(value, dateInterval)
  }
});

export const getYAxisOptions = (dataProp: string): BarGraphYAxisOptions => ({
  type: 'value',
  max: 'dataMax',
  splitNumber: 10,
  nameGap: 10,

  nameTextStyle: {
    color: '#3a3a3a'
  },

  axisTick: {
    alignWithLabel: true,
    length: 9
  },

  axisLine: {
    lineStyle: {
      color: '#e0e0e0'
    }
  },

  axisLabel: {
    formatter: value => (
      dataProp === ENGAGEMENT_RATE ? `${value.toFixed(2)}%` : abbrNum(value, {}, true)
    ),
    color: '#3a3a3a',
    margin: 13,
    showMinLabel: false,
    showMaxLabel: false
  },

  splitLine: {
    show: true,
    lineStyle: {
      color: '#ebebeb',
      type: 'dashed'
    }
  }
});

export const getDataZoomOptions = (): Array<BarGraphDataZoom> => [{
  type: 'inside',
  xAxisIndex: [0],
  start: 0,
  end: 100
}];

export const getYAxisOptionsForAudience = (): BarGraphYAxisOptions => ({
  type: 'value',
  splitNumber: 5,

  axisLabel: {
    formatter: value => `${abbrNum(value)}`,
    color: '#3a3a3a',
    padding: [0, 15, 0, 0]
  },

  axisLine: {
    lineStyle: {
      color: '#e0e0e0'
    }
  },

  axisTick: {
    show: true,
    alignWithLabel: false,
    length: 15,
    lineStyle: {
      type: 'solid',
      width: 1,
      color: '#e0e0e0'
    }
  },

  splitLine: {
    show: false
  }
});

export const getXAxisOptionsForAudience = (data: Array<StringNumber>): BarGraphXAxisOptions => ({
  type: 'category',
  data,

  axisLine: {
    lineStyle: {
      color: '#e0e0e0'
    }
  },

  axisLabel: {
    color: '#3a3a3a',
    // @ts-ignore
    formatter: undefined
  }
});
